module.exports = require('./lib/index.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-csv/index.js
 ** module id = 1015
 ** module chunks = 0
 **/